import axiosInstance from "../lib/axios.instance";
import { IGetGroupsResponse } from "../types/group.types";

export const getGroups = async (): Promise<IGetGroupsResponse> => {
  const response = await axiosInstance.get<IGetGroupsResponse>("teams/groups/");
  return response.data;
};
